export function classifyField(f) {
    const importBehaviors = f.stageMap.import ?? [];
    for (const b of importBehaviors) {
        if (b.kind === 'populate' && (b.source.type === 'header-xpath' || b.source.type === 'header-path')) {
            return 'header';
        }
    }
    for (const stageBehaviors of Object.values(f.stageMap)) {
        for (const b of stageBehaviors ?? []) {
            if (b.kind === 'compute') {
                return b.dependsOn.length === 0 && isLiteralExpression(b.formula.source) ? 'static' : 'computed';
            }
        }
    }
    return 'body';
}
function isLiteralExpression(src) {
    const trimmed = src.trim();
    if (/^'[^']*'$/.test(trimmed) || /^"[^"]*"$/.test(trimmed))
        return true;
    if (/^-?\d+(\.\d+)?$/.test(trimmed))
        return true;
    if (trimmed === 'true' || trimmed === 'false' || trimmed === 'null')
        return true;
    return false;
}
//# sourceMappingURL=field-classifier.js.map